import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { utm } from "url-utm-params";

const CookieSetter = ({ location }) => {
  const [utmParams, setUtmParams] = useState({});
  // eslint-disable-next-line
  const { utm_source, utm_medium, utm_campaign, utm_content } = utmParams;

  useEffect(() => {
    if (location.search) {
      setUtmParams(utm(location.search));
    }
    // eslint-disable-next-line
    if (utm_source) {
      // eslint-disable-next-line
      Cookies.set("utm_source_util", utm_source);
    }
    // eslint-disable-next-line
    if (utm_medium) {
      // eslint-disable-next-line
      Cookies.set("utm_medium_util", utm_medium);
    }
    // eslint-disable-next-line
    if (utm_campaign) {
      // eslint-disable-next-line
      Cookies.set("utm_campaign_util", utm_campaign);
    }
    // eslint-disable-next-line
    if (utm_content) {
      // eslint-disable-next-line
      Cookies.set("utm_content_util", utm_content);
    }
    // eslint-disable-next-line
    if (location.pathname) {
      // eslint-disable-next-line
      Cookies.set("track_lead_page_util", location.pathname);
    }
    if (!Cookies.get("entry_page_util")) {
      Cookies.set("entry_page_util", location.pathname);
    }
  }, [
    location,
    setUtmParams,
    // eslint-disable-next-line
    utm_source,
    // eslint-disable-next-line
    utm_medium,
    // eslint-disable-next-line
    utm_campaign,
    // eslint-disable-next-line
    utm_content,
  ]);

  return <div>{/* Empty for Cookie Component */}</div>;
};

export default CookieSetter;
